export const createToDoModal = {
  title: 'To-do erstellen',
  buttonText: 'Erstellen',
  errorToastText: 'To-do konnte nicht erstellt werden',
}
